import { createApp } from 'petite-vue/dist/petite-vue.es'
import objectFitImages from 'object-fit-images'
import Accordion from 'accordion-js'
import isMobile from 'ismobilejs'
import form from '../form'
import {
  autocomplete,
  bgTextAnimation,
  counterAnimation,
  customSelects,
  GoogleMap,
  initRangeSlider,
  initShuffle,
  initStaggerList,
  initSwitcher,
  initTabs,
  initTextDecorationAnimation,
  inputCollapsedAnimation,
  lazyLoad,
  shuffleLoadMore,
  simpleDropdown,
  StepForm,
  swiperObserver,
  initScrollTo,
  init360Modal,
  initNumberInputs,
} from './index'
import { lazyImageAttr, swiperAttr } from './_constants'
import initTabContent from './initTabContent'
import ajaxForm from './ajaxForm'
import Dropdown from './Dropdown'
import LimitLines from './LimitLines'
import CurrencyList from './CurrencyList'
import { initCssAnimations } from './cssAnimationsObserver'
import { propertyCardsList } from '../vue-app'

const eventListenersRemover = []
const tickerRemover = []
let hasSeenPreloader =
  Boolean(localStorage.getItem('hasSeenPreloader')) || false

const initDomWithoutVue = page => {
  createApp().mount()

  objectFitImages()
  customSelects(page, eventListenersRemover)
  initShuffle(page, [shuffleLoadMore])
  inputCollapsedAnimation(page)
  simpleDropdown(page, eventListenersRemover)
  initSwitcher(page, eventListenersRemover)
  initStaggerList(page)
  autocomplete(page)
  initScrollTo(page)
  init360Modal(page)

  if (!isMobile(window.navigator).any) {
    tickerRemover.push(bgTextAnimation(page))
  }

  const stepForm = page.querySelector('[data-step-form]')

  if (stepForm) {
    const formObj = new StepForm(stepForm)
    // formObj.startIndex = 7
    // formObj.prefill = true
    formObj.init()
  }

  if (!hasSeenPreloader) {
    window.addEventListener('preloaderEnd', () => initCssAnimations(page))
    localStorage.setItem('hasSeenPreloader', 'true')
    hasSeenPreloader = true
    eventListenersRemover.push({
      el: window,
      event: 'preloaderEnd',
      func: () => initCssAnimations(page),
    })
  } else {
    window.removeEventListener('preloaderEnd', () => initCssAnimations(page))
    initCssAnimations(page)
  }

  page.querySelectorAll('[data-counter-animations]').forEach(el => {
    counterAnimation(el)
  })

  page.querySelectorAll('[data-accordion-container]').forEach(container => {
    const accordion = new Accordion(container, {
      duration: 500,
      showMultiple: true,
    })

    if ('openDefaultFirst' in container.dataset) {
      accordion.open(0)
    }
  })

  page.querySelectorAll('[data-currency-list]').forEach(el => {
    new CurrencyList(el)
  })

  page.querySelectorAll('[data-dropdown]').forEach(el => {
    new Dropdown(el)
  })

  page.querySelectorAll('[data-limit-lines]').forEach(el => {
    new LimitLines(el)
  })

  page.querySelectorAll(lazyImageAttr).forEach(img => {
    lazyLoad.observe(img)
  })

  page.querySelectorAll('[data-decoration-section]').forEach(el => {
    initTextDecorationAnimation(el)
  })

  page
    .querySelectorAll('[data-tabs]')
    .forEach(tabs =>
      initTabs(tabs, page, initTabContent, eventListenersRemover)
    )

  page.querySelectorAll(swiperAttr).forEach(swiper => {
    swiperObserver.observe(swiper)
  })
  page.querySelectorAll('[data-range]').forEach(el => {
    initRangeSlider(el, page, eventListenersRemover)
  })

  form(page)
  ajaxForm(page)

  const map = page.querySelector('[data-google-map]')
  const mapAutocomplete = page.querySelector('[data-google-map-autocomplete]')

  if (map) {
    const googleMap = new GoogleMap(map)

    if (mapAutocomplete) {
      googleMap.addAutocomplete(mapAutocomplete)
    }
  }

  initNumberInputs(page)

  return { eventListenersRemover, tickerRemover }
}
export const withVue = (page, callback) => {
  const promises = Array.from(page.querySelectorAll('[data-vue-app]')).map(
    el => new Promise(resolve => propertyCardsList({ el, mounted: resolve }))
  )

  return Promise.all(promises).then(() => callback(page))
}

/**
 * We're making sure that virtual DOM provided by Vue is initialized before anything else
 * so that rest of our JS is initializing both normal DOM rendered from Twig,
 * as well as virtual DOM, generated by Vue.js
 */
export default page => withVue(page, initDomWithoutVue)
